import { useMemo } from 'react';
import { columns } from './constants';

const useFooterRow = ({ rows }) => {
  return useMemo(
    () => ({
      floorPlan: '',
      bedsBaths: '',
      numUnits: {
        value: rows.reduce((acc, row) => acc + row.numUnits.value, 0),
        variant: 'number',
      },
      ...Object.keys(columns).reduce((acc, column) => {
        return {
          ...acc,
          [`current${column}`]: {
            value:
              rows.reduce(
                (acc, row) => acc + row[`current${column}`].value,
                0,
              ) || null,
            variant: 'currency',
          },
          [`total${column}Income`]: {
            value:
              rows.reduce(
                (acc, row) => acc + row[`total${column}Income`].value,
                0,
              ) || null,
            variant: 'currency',
          },
          [`new${column}`]: {
            value:
              rows.reduce((acc, row) => acc + row[`new${column}`].value, 0) ||
              null,
            variant: 'currency',
          },
          [`new${column}PotentialIncome`]: {
            value:
              rows.reduce(
                (acc, row) => acc + row[`new${column}PotentialIncome`].value,
                0,
              ) || null,
            variant: 'currency',
          },
        };
      }, {}),
    }),
    [rows],
  );
};

export default useFooterRow;
